import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Stack,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import getUser from "../../api/user/getUser";
import addUserCoupon from "../../api/user/addCoupon";
import getCoupons from "../../api/coupon/getCoupons";
import getUserCoupons from "../../api/user/getUserCoupons";
import ConfirmDialog from "../../component/ConfirmDialog";
import invalidateCoupon from "../../api/user/invalidateCoupon";
function UserPage() {
  const [user, setUser] = useState(null);
  const [searchPhone, setSearchPhone] = useState("");
  const [error, setError] = useState(null);
  const [selectedCoupon, setSelectedCoupon] = useState("");
  const [tempCoupons, setTempCoupons] = useState([]);
  const [coupons, setCoupons] = useState([]);
  const [addConfirmOpen, setAddConfirmOpen] = useState(false);
  const [removeConfirmOpen, setRemoveConfirmOpen] = useState(false);
  const [couponToRemove, setCouponToRemove] = useState("");
  useEffect(() => {
    const fetchCoupons = async () => {
      try {
        const data = await getCoupons();

        setCoupons(data.Coupons);
      } catch (err) {
        setError(err.message);
      }
    };

    if (coupons) {
      fetchCoupons();
    }
  }, []);
  useEffect(() => {
    fetchUserCoupons();
  }, [user]);
  const fetchUserCoupons = async () => {

    try {
      const responseData = await getUserCoupons(user.Id);
      if (responseData.code === "000") {
        if (responseData.coupons) {

          setTempCoupons(responseData.coupons);
        }else{
          setTempCoupons([]);
        }
      } else {
        setTempCoupons([]);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const handleSearch = async () => {

    try {
      const fetchedUser = await getUser(searchPhone);
      setUser(fetchedUser.user);

      setError(null);
    } catch (err) {
      setUser(null);
      setError(err.message);
    }


  };
  const refresh = async () => {
    try {

      const fetchedUser = await getUser(user.Phone);
      setUser(fetchedUser.user);

      setError(null);
    } catch (err) {
      setUser(null);
      setError(err.message);
    }

    fetchUserCoupons();
  };
  const AddButtonClicked = () => {
    setAddConfirmOpen(true);
  };
  const handleAddCoupon = () => {
    const addNewUserCoupon = async () => {
      try {
        const responseData = await addUserCoupon(user.Id, selectedCoupon);
        setError(null);
        refresh();
        // Optionally: Refresh user data to reflect the changes or merge tempCoupons with user.Coupons.
      } catch (err) {
        setError(`Failed to save coupons: ${err.message}`);
      }
    };

    addNewUserCoupon();
  };

  const handleRemoveCoupon = (coupon) => {
    const invalidateUserCoupon = async () => {

      try {
        const responseData = await invalidateCoupon(user.Id, coupon.Id);
        setError(null);
        refresh();
        // Optionally: Refresh user data to reflect the changes or merge tempCoupons with user.Coupons.
      } catch (err) {
        setError(`Failed to invalidate coupons: ${err.message}`);
      }
    };

    invalidateUserCoupon();
  };

  return (
    <div>
      <Stack direction={"row"} alignItems={"center"} spacing={1}>
        <TextField
          label="輸入用戶手機號碼"
          variant="outlined"
          color="secondary"
          value={searchPhone}
          onChange={(e) => setSearchPhone(e.target.value)}
          sx={{ background: "#ffffff" }}
        />
        <Button onClick={handleSearch} variant="contained" color="secondary">
          搜尋
        </Button>
      </Stack>
      {error && (
        <Typography color="error" style={{ marginTop: "20px" }}>
          {error}
        </Typography>
      )}

      {user && (
        <Card style={{ marginTop: "20px" }}>
          <CardContent>
            <Typography variant="h5">姓名: {user.Name}</Typography>
            <Typography variant="body1">手機: {user.Phone}</Typography>
            <Typography variant="body1">角色: {user.Role}</Typography>
            <Typography variant="body1">狀態: {user.Status}</Typography>
            <Typography variant="body1">
              最後登入: {user.LastLoggedInAt}
            </Typography>

            <Divider style={{ margin: "20px 0" }} />
            <Typography variant="h6">優惠券:</Typography>
            <List>
              {tempCoupons && tempCoupons.length > 0 ? (
                tempCoupons.map((coupon, idx) => (
                  <ListItem key={idx}>
                    <ListItemText primary={idx + 1 + "." + coupon.Name} />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        onClick={() => {
                          setRemoveConfirmOpen(true);
                          setCouponToRemove(coupon);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                ))
              ) : (
                <ListItem>
                  <ListItemText primary="無" />
                </ListItem>
              )}
            </List>

            <Divider style={{ margin: "20px 0" }} />
            <Typography variant="h6">新增優惠券:</Typography>
            <Grid container spacing={2}>
              <Grid item xs={8}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel>優惠券</InputLabel>
                  <Select
                    label="優惠券"
                    value={selectedCoupon}
                    onChange={(e) => setSelectedCoupon(e.target.value)}
                  >
                    {coupons?.map((coupon, index) => (
                      <MenuItem key={index} value={coupon}>
                        {coupon?.Name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Button
                  onClick={AddButtonClicked}
                  variant="contained"
                  color="primary"
                >
                  新增
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      )}
      <ConfirmDialog
        open={addConfirmOpen}
        onClose={() => {
          setAddConfirmOpen(false);
        }}
        title={"新增優惠券"}
        content={"是否新增優惠券"}
        onConfirm={handleAddCoupon}
      ></ConfirmDialog>
      <ConfirmDialog
        open={removeConfirmOpen}
        onClose={() => {
          setRemoveConfirmOpen(false);
        }}
        title={"刪除優惠券"}
        content={"是否刪除優惠券"}
        onConfirm={() => {
          handleRemoveCoupon(couponToRemove);
        }}
      ></ConfirmDialog>
    </div>
  );
}

export default UserPage;
